const getSkipWaitingRoom = () => JSON.parse(localStorage.getItem('skipWaitingRoom'))

const saveSkipWaitingRoom = (skipWaitingRoom) => {
  localStorage.setItem('skipWaitingRoom', JSON.stringify(skipWaitingRoom))
}
const removeSkipWaitingRoom = () => {
  localStorage.removeItem('skipWaitingRoom')
}

export default {
  getSkipWaitingRoom,
  saveSkipWaitingRoom,
  removeSkipWaitingRoom,
}
